import { render, staticRenderFns } from "./minimal.vue?vue&type=template&id=d83364d2&scoped=true&"
import script from "./minimal.vue?vue&type=script&lang=js&"
export * from "./minimal.vue?vue&type=script&lang=js&"
import style0 from "./minimal.vue?vue&type=style&index=0&id=d83364d2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83364d2",
  null
  
)

export default component.exports